import '@/prototypes/array';


export default {
    name: 'hospital',

    namespaced: true,

    state: {
        sites: null,
        contact:null
    },

    getters: {
        sites(state) {
            return state.sites;
        },
        contact(state) {
            return state.contact;
        }
    },

    mutations: {
        SITES(state, sites) {
            state.sites = sites;
            if (!state.sites) return;
        },

        CONTACT(state, contact){
            state.contact = contact;
            if (!state.contact) return;
        },

        CHANGE_CONTACT_DETAILS (state, data) {
            var contactID = data.id;
            delete data.id;
            for(var i = 0; i < state.sites.length; i++){
                for(var j = 0; j < state.sites[i].contacts.length; j++){
                    if(state.sites[i].contacts[j].id == contactID){
                        state.sites[i].contacts[j].email = data.email;
                        state.sites[i].contacts[j].firstName = data.firstName;
                        state.sites[i].contacts[j].lastName = data.lastName;
                        state.sites[i].contacts[j].phoneWork = data.phoneWork;
                        state.sites[i].contacts[j].phoneMobile = data.phoneMobile;
                        state.sites[i].contacts[j].jobTitle = data.jobTitle;
                        state.sites[i].contacts[j].salutation = data.salutation;
                        state.sites[i].contacts[j].title = data.title;
                    }
                }
            }  


            state.contact.firstName = data.firstName;
            state.contact.lastName = data.lastName;
            state.contact.phoneMobile = data.phoneMobile;
            state.contact.phoneWork = data.phoneWork;
            state.contact.jobTitle = data.jobTitle;

            if (!state.sites) return;
        },

        CHANGE_HOSPITAL_NAME (state, data){
            for(var i = 0; i < state.sites.length; i++){
                if(state.sites[i].id == data.id){
                    state.sites[i].locationName = data.name;
                }
            }

            if (!state.sites) return;
        },

        UPDATE_TICKETS(state, data){
            for(var i = 0; i < state.sites.length; i++){
                if(state.sites[i].id == data.system.siteID){
                    state.sites[i].supportTicketsCount++;
                    state.sites[i].supportTickets.push(data.ticket);
                }
            }
            if (!state.sites) return;
        },

        RESET_STATE(state){
            state.sites =  null;
            state.contact = null;
        }
    },

    actions: {
        sites({ commit }, sites) {
            commit('SITES', sites);
        },
        contact({ commit }, contact) {
            commit('CONTACT', contact);
        },
        changeContactDetails ({ commit }, data) {
            commit('CHANGE_CONTACT_DETAILS', data);
        },
        changeHospitalName ({ commit }, data){
            commit('CHANGE_HOSPITAL_NAME', data);
        },

        updateTickets({ commit }, data){
            commit('UPDATE_TICKETS', data);
        },

        resetState({commit}){
            commit('RESET_STATE');
        }
    }
};